import React from "react";
import { Music, Playlist } from "./types/global.type";

interface StateContextType {
  playMusic: boolean;
  setPlayMusic: React.Dispatch<React.SetStateAction<boolean>>;
  volume: number;
  setVolume: React.Dispatch<React.SetStateAction<number>>;
  currentPlaylist: Playlist | null;
  setCurrentPlaylist: React.Dispatch<React.SetStateAction<Playlist | null>>;
  currentMusic: Music | null;
  setCurrentMusic: React.Dispatch<React.SetStateAction<Music | null>>;
  listPlaylist: Playlist[];
  setListPlaylist: React.Dispatch<React.SetStateAction<Playlist[]>>;

  audioRef: React.MutableRefObject<HTMLAudioElement | null>;
}

const StateContext = React.createContext<StateContextType>(
  {} as StateContextType
);

export default StateContext;
